import * as React from 'react'

import { Box, Button, Icon, type MediumIcon, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import type ContractVersion from 'modules/contracts/store/models/ContractVersion'
import type Employee from 'modules/employees/store/models/Employee'

interface Props {
  icon: MediumIcon
  title: string
  description: string
  buttonText: string
  employee: Employee
  contractVersion: ContractVersion
}

const Blank = ({ icon, title, description, buttonText, employee, contractVersion }: Props) => {
  const { navigation } = useNavigation()

  return (
    <Box
      gridColSpan={{ xxs: 12 }}
      padding="s24"
      justifyContent="center"
      alignItems="center"
      gap="s16"
      width="full"
    >
      <Icon.Medium icon={icon} />
      <Box textAlign="center" gap="s4">
        <Text.Normal color="grey1000" weight="semibold" size="300">
          {title}
        </Text.Normal>
        <Text.Normal color="grey800" weight="normal" size="200">
          {description}
        </Text.Normal>
      </Box>
      <Box paddingTop="s16">
        <Button.Router
          type="secondary"
          to={navigation.employees.id.contractVersions.fix.fullPath({
            id: employee.id.toString(),
            contractVersionId: contractVersion.id.toString(),
          })}
        >
          {buttonText}
        </Button.Router>
      </Box>
    </Box>
  )
}

export default observer(Blank)
